import axios from 'axios'
import {base_url} from "./baseUrl";
import {useUser} from "../store/user";


const instance = axios.create({
    baseURL: base_url,
    headers: {
        "Content-Type": "application/json",
    }
})

// 添加请求拦截器
instance.interceptors.request.use(
    (config) => {
        // 在请求发送之前做一些处理，比如添加token到请求头
        // config.headers.Authorization = `Bearer ${token}`;
        const token = window.localStorage.getItem('mine-token');
        if (token) {
            config.headers['token'] = token
        }
        return config;
    },
    (error) => {
        // 对请求错误做些什么
        return Promise.reject(error);
    }
);

// 添加响应拦截器
instance.interceptors.response.use(
    (response) => {
        // 对响应数据做点什么
        if (response.data.code != 1){
            return Promise.reject(response.data);
        }
        return response.data;
    },
    (error) => {
        //如果是 401 无效token 跳转登录
        if (error.response.data.code == 401) {
            useUser().clearToken()
            window.location.href = '/'
        }
        // 对响应错误做点什么
        return Promise.reject(error.response.data);
    }
);

export default instance;
